import { PROYECTOS_API_REMOTE_BASE } from "../config/proyectosApiRemoteUrl";

function stripTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, "");
}

function isLocalhostUrl(value: string): boolean {
  return /localhost|127\.0\.0\.1/i.test(value);
}

/**
 * Base del API Nest (`main.ts` → `setGlobalPrefix('proyectos')`).
 * - Por defecto usa el servidor remoto EMCALI.
 * - En produccion nunca usa localhost (evita .env/.env.local incorrectos en Hostinger).
 */
export function getProyectosApiBaseUrl(): string {
  let base = stripTrailingSlashes(String(process.env.REACT_APP_BACKEND_URL || "").trim());

  if (!base || isLocalhostUrl(base)) {
    base = PROYECTOS_API_REMOTE_BASE;
  }

  while (/\/proyectos\/proyectos$/i.test(base)) {
    base = stripTrailingSlashes(base.replace(/\/proyectos$/i, ""));
  }
  if (!/\/proyectos$/i.test(base)) {
    base = `${base}/proyectos`;
  }
  return base;
}
